import { render } from "./CustomSelectOneLaboratory.vue?vue&type=template&id=7173c7d5"
import script from "./CustomSelectOneLaboratory.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneLaboratory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__